module.exports = import("https://esm.sh/@tiptap/extension-hard-break@2.4.0");;